import { graphql } from "../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

const SendResetPasswordEmailMutation = graphql(`
  mutation sendUserResetPasswordEmailByUserId($userId: String!) {
    sendUserResetPasswordEmailByUserId(userId: $userId)
  }
`);

export function useSendResetPasswordEmail() {
  const [sendResetPasswordEmailMutation, { loading }] = useMutation(
    SendResetPasswordEmailMutation,
  );

  const sendResetPasswordEmail = useCallback(
    async (userId: string): Promise<boolean> => {
      const { data } = await sendResetPasswordEmailMutation({
        variables: { userId },
      });
      return data?.sendUserResetPasswordEmailByUserId ?? false;
    },
    [sendResetPasswordEmailMutation],
  );

  return {
    sendResetPasswordEmail,
    loading,
  };
}
